import React from 'react';
import ModelWorking from '../common/model-working';
import KEY from '../common/keylist';
type Props = {
    title: string;
    desc: any;
};

const ModelsOfWorking: React.FC<Props> = ({ title, desc }) => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-10 lg:col-start-2 pb-50">
                        <p
                            className="text-primary mb-2.5 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Models of Working
                        </p>
                        <h2 className=" mb-2.5" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            {/* Engagement models to hire the best developers */}
                            {title}
                        </h2>
                        <p className="fw-600 mb-0" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            {desc}
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2 text-secondary">
                    <ModelWorking
                        path={'/img/technology/ic-dedicated-team.svg'}
                        height={64}
                        width={64}
                        alt="dedicated-team"
                        title="dedicated-team"
                        modelWorkingTitle="Dedicated Team"
                        url={'/dedicated-team-model'}
                    >
                        <>
                            <KEY text="Total control over the project" className="fs-md" />
                            <KEY text="Dedicated resources" className="fs-md" />
                            <KEY text="Close collaboration" className="fs-md" />
                            <KEY text="Scalable team size" className="fs-md" />
                            <KEY text="Seamless communication" className="fs-md" />
                            <KEY text="Long-term commitment" className="fs-md" />
                        </>
                    </ModelWorking>
                    <ModelWorking
                        path={'/img/technology/ic-fixed-cost.svg'}
                        height={64}
                        width={64}
                        alt="fixed-cost"
                        title="fixed-cost"
                        modelWorkingTitle="Fixed Cost"
                        url={'/fixed-cost-model'}
                    >
                        <>
                            <KEY text="Predefined budget" className="fs-md" />
                            <KEY text="Well-defined project scope" className="fs-md" />
                            <KEY text="Predictable costs" className="fs-md" />
                            <KEY text="Reduced financial risks" className="fs-md" />
                            <KEY text="Better budget planning" className="fs-md" />
                            <KEY text="Best for fixed requirements" className="fs-md" />
                        </>
                    </ModelWorking>
                    <ModelWorking
                        path={'/img/technology/ic-time-material.svg'}
                        height={64}
                        width={64}
                        alt="time-material"
                        title="time-material"
                        modelWorkingTitle="Time & Material"
                        url={'/time-material-model'}
                    >
                        <>
                            <KEY text="Adaptable to changing needs" className="fs-md" />
                            <KEY text="Easily track project progress" className="fs-md" />
                            <KEY text="Adjusts project scope or requirements" className="fs-md" />
                            <KEY text="Best for projects with uncertain needs" className="fs-md" />
                            <KEY text="Allows for incremental development" className="fs-md" />
                            <KEY text="Full authority over the project" className="fs-md" />
                        </>
                    </ModelWorking>
                </div>
            </div>
        </div>
    );
};

export default ModelsOfWorking;
